export const WS_URL = 'wss://norma.nomoreparties.space/';
export const WS_ORDERS = 'orders?token=';
export const WS_ORDERS_ALL = 'orders/all';